import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

import { ErrorBand } from "./ErrorBand";

/** A class, because React still has no hook that catches a render throw. Without
 *  one, any exception below the router unmounts the whole tree and leaves a
 *  white page — indistinguishable from a page that never loaded at all. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("render failed", error, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <ErrorBand
          message="Something broke while drawing this page."
          hint="Reload the page. If it happens again on the same page, the fault is in the page, not the data."
        />
      );
    }
    return this.props.children;
  }
}
